import { IStyle } from '@fluentui/react';

export interface IFunnelChartStyles {
  root: IStyle;
}

export interface IFunnelChartClassNames {
  root: string;
}

export const funnelChartStylesDefault: Partial<IFunnelChartStyles> = {
  root: {
    height: '100%',
  },
};
